import { InferType, object, string } from 'yup';

import { MAX_EMAIL_LENGTH } from '@/shared/config';

export const resetPasswordSchema = object({
  email: string().email().required().max(MAX_EMAIL_LENGTH),
});

export type ResetPasswordSchemaFormPayload = InferType<
  typeof resetPasswordSchema
>;
